import { Container, createStyles, Text, Title } from '@mantine/core'
import { NextPage } from 'next'
import React from 'react'

const useStyles = createStyles((theme) => ({
  title: {
    textAlign: 'center',
    fontWeight: 900,
    fontSize: 38,
    marginBottom: theme.spacing.xl,

    [theme.fn.smallerThan('sm')]: {
      fontSize: 32
    }
  },
  subtitle: {
    textAlign: 'left',
    fontWeight: 700,
    fontSize: 24,
    marginBottom: theme.spacing.lg,

    [theme.fn.smallerThan('sm')]: {
      fontSize: 20
    }
  },
  text: {
    marginBottom: theme.spacing.md,
    lineHeight: 1.6
  },
  list: {
    marginBottom: theme.spacing.md,
    paddingLeft: theme.spacing.lg
  }
}))

const PrivacyPolicy: NextPage = () => {
  const { classes } = useStyles()

  return (
    <Container>
      <Title className={classes.title}>Privacy Policy</Title>
      <Text className={classes.text}>Our Privacy Policy was last updated on July 14, 2023</Text>
      <Text className={classes.text}>
        This Privacy Policy describes Our policies and procedures on the collection, use and disclosure of Your
        information when You use the Service and tells You about Your privacy rights and how the law protects You.
      </Text>
      <Text className={classes.text}>
        We use Your Personal data to provide and improve the Service. By using the Service, You agree to the collection
        and use of information in accordance with this Privacy Policy.
      </Text>
      <Title className={classes.subtitle}>I. Interpretation</Title>
      <Text className={classes.text}>
        The words of which the initial letter is capitalized have meanings defined under the following conditions. The
        following definitions shall have the same meaning regardless of whether they appear in singular or in plural.
      </Text>
      <Title className={classes.subtitle}>Definitions</Title>
      <ul className={classes.list}>
        <li className={classes.text}>
          <strong>Account</strong> means a unique account created for You to access our Service or parts of our Service.
        </li>
        <li className={classes.text}>
          <strong>Business</strong>, for the purpose of the CCPA (California Consumer Privacy Act), refers to the
          Company as the legal entity that collects Consumers&apos; personal information and determines the purposes and
          means of the processing of Consumers&apos; personal information, or on behalf of which such information is
          collected and that alone, or jointly with others, determines the purposes and means of the processing of
          consumers&apos; personal information, that does business in the State of California. For the purpose of the
          GDPR (General Data Protection Regulation), “Business” refers to the Company as the legal entity that collects
          Consumers&apos; personal information and determines the purposes and means of the processing of
          Consumers&apos; personal information, or on behalf of which such information is collected and that alone, or
          jointly with others, determines the purposes and means of the processing of consumers&apos; personal
          information, that does business in the European Union.
        </li>
        <li className={classes.text}>
          <strong>Company</strong> (referred to as either &quot;the Company&quot;, &quot;We&quot;, &quot;Us&quot; or
          &quot;Our&quot; in this Agreement) refers to SWAP Integration LLC.
        </li>
        <li className={classes.text}>
          <strong>Country</strong> refers to United States.
        </li>
        <li className={classes.text}>
          <strong>Consumer</strong>, for the purpose of the CCPA (California Consumer Privacy Act), means a natural
          person who is a California resident. A resident, as defined in the law, includes (1) every individual who is
          in the USA for other than a temporary or transitory purpose, and (2) every individual who is domiciled in the
          USA who is outside the USA for a temporary or transitory purpose. &ldquo;Consumer&ldquo;, for the purpose of
          the GDPR (General Data Protection Regulation), means a natural person who is a legally recognized citizen of a
          jurisdiction within the European Union.
        </li>
        <li className={classes.text}>
          <strong>Cookies</strong> are small files that are placed on Your computer, mobile device or any other device
          by a website, containing the details of Your browsing history on that website among its many uses.
        </li>
        <li className={classes.text}>
          <strong>Device</strong> means any device that can access the Service such as a computer, a cell phone or a
          digital tablet.
        </li>
        <li className={classes.text}>
          <strong>Do Not Track (DNT)</strong> is a concept that has been promoted by US regulatory authorities, in
          particular the U.S. Federal Trade Commission (FTC), for the Internet industry to develop and implement a
          mechanism for allowing internet users to control the tracking of their online activities across websites.
        </li>
        <li className={classes.text}>
          <strong>Personal Data</strong> is any information that relates to an identified or identifiable individual.
          <ul className={classes.list}>
            <li className={classes.text}>
              For the purposes of the CCPA and GDPR, Personal Data means any information that identifies, relates to,
              describes or is capable of being associated with, or could reasonably be linked, directly or indirectly,
              with You.
            </li>
          </ul>
        </li>
        <li className={classes.text}>
          <strong>Sale</strong>, for the purpose of the CCPA and GDPR, means selling, renting, releasing, disclosing,
          disseminating, making available, transferring, or otherwise communicating orally, in writing, or by electronic
          or other means, a Consumer&apos;s personal information to another business or a third party for monetary or
          other valuable consideration.
        </li>
        <li className={classes.text}>
          <strong>Service</strong> refers to the Website and any software application intended for Consumer use offered
          by the Company.
        </li>
        <li className={classes.text}>
          <strong>Service Provider</strong> means any natural or legal person who processes the data on behalf of the
          Company. It refers to third-party companies or individuals employed by the Company to facilitate the Service,
          to provide the Service on behalf of the Company, to perform services related to the Service or to assist the
          Company in analyzing how the Service is used.
        </li>
        <li className={classes.text}>
          <strong>Usage Data</strong> refers to data collected automatically, either generated by the use of the Service
          or from the Service infrastructure itself (for example, the duration of a page visit).
        </li>
        <li className={classes.text}>
          <strong>Website</strong> refers to SWAPIntegration.com <a>www.swappm.com</a>
        </li>
        <li className={classes.text}>
          <strong>You</strong> means the individual accessing or using the Service, or the company, or other legal
          entity on behalf of which such individual is accessing or using the Service, as applicable.
        </li>
      </ul>
      <Title className={classes.subtitle}>II. Collecting and Using Your Personal Data</Title>
      <Title className={classes.subtitle}>Types of Data Collected:</Title>
      <Title className={classes.subtitle}>1. Personal Data</Title>
      <Text className={classes.text}>
        While using Our Service, We may ask You to provide Us with certain personally identifiable information that can
        be used to contact or identify You. Personally identifiable information may include, but is not limited to:
      </Text>
      <ul className={classes.list}>
        <li className={classes.text}>Email address</li>
        <li className={classes.text}>First name and last name</li>
        <li className={classes.text}>Phone number</li>
        <li className={classes.text}>Address, State, Province, ZIP/Postal code, City</li>
      </ul>
      <Title className={classes.subtitle}>2. Usage Data</Title>
      <Text className={classes.text}>
        Usage Data is collected automatically when using the Service. Usage Data may include information such as Your
        Device&apos;s Internet Protocol address (e.g. IP address), browser type, browser version, the pages of our
        Service that You visit, the time and date of Your visit, the time spent on those pages, unique device
        identifiers and other diagnostic data.
      </Text>
      <Text className={classes.text}>
        When You access the Service by or through a mobile device, We may collect certain information automatically,
        including, but not limited to, the type of mobile device You use, Your mobile device unique ID, the IP address
        of Your mobile device, Your mobile operating system, the type of mobile Internet browser You use, unique device
        identifiers and other diagnostic data.
      </Text>
      <Text className={classes.text}>
        We may also collect information that Your browser sends whenever You visit our Service or when You access the
        Service by or through a mobile device.
      </Text>
      <Title className={classes.subtitle}>III. Tracking Technologies and Cookies</Title>
      <Text className={classes.text}>
        Where permitted by applicable law, We use Cookies and similar tracking technologies to track the activity on Our
        Service and store certain information. Tracking technologies used are beacons, tags, and scripts to collect and
        track information and to improve and analyze Our Service. The technologies We use may include:
      </Text>
      <ul className={classes.list}>
        <li className={classes.text}>
          <strong>Cookies or Browser Cookies.</strong> A cookie is a small file placed on Your Device. You can instruct
          Your browser to refuse all Cookies or to indicate when a Cookie is being sent. However, if You do not accept
          Cookies, You may not be able to use some parts of our Service. Unless you have adjusted Your browser setting
          so that it will refuse Cookies, our Service may use Cookies.
        </li>
        <li className={classes.text}>
          <strong>Web Beacons.</strong> Certain sections of our Service and our emails may contain small electronic
          files known as web beacons (also referred to as clear gifs, pixel tags, and single-pixel gifs) that permit the
          Company, for example, to count users who have visited those pages or opened an email and for other related
          website statistics (for example, recording the popularity of a certain section and verifying system and server
          integrity). Cookies can be &ldquo;Persistent&ldquo; or &ldquo;Session&ldquo; Cookies. Persistent Cookies
          remain on Your personal computer or mobile device when You go offline, while Session Cookies are deleted as
          soon as You close Your web browser.
        </li>
      </ul>
      <Text className={classes.text}>We use both Session and Persistent Cookies for the purposes set out below:</Text>
      <ul className={classes.list}>
        <li className={classes.text}>
          <strong>Necessary / Essential Cookies</strong>
          <ul className={classes.list}>
            <li className={classes.text}>Type: Session Cookies</li>
            <li className={classes.text}>Administered by: Us</li>
            <li className={classes.text}>
              Purpose: These Cookies are essential to provide You with services available through the Website and to
              enable You to use some of its features. They help to authenticate users and prevent fraudulent use of user
              accounts. Without these Cookies, the services that You have asked for cannot be provided, and We only use
              these Cookies to provide You with those services. You may opt out of such Cookies by not using the
              Service.
            </li>
          </ul>
        </li>
        <li className={classes.text}>
          <strong>Cookies Policy / Notice Acceptance Cookies</strong>
          <ul className={classes.list}>
            <li className={classes.text}>Type: Persistent Cookies</li>
            <li className={classes.text}>Administered by: Us</li>
            <li className={classes.text}>
              Purpose: These Cookies identify if users have accepted the use of cookies on the Website.
            </li>
          </ul>
        </li>
        <li className={classes.text}>
          <strong>Functionality Cookies</strong>
          <ul className={classes.list}>
            <li className={classes.text}>Type: Persistent Cookies</li>
            <li className={classes.text}>Administered by: Us</li>
            <li className={classes.text}>
              Purpose: These Cookies allow us to remember choices You make when You use the Website, such as remembering
              your login details or language preference. The purpose of these Cookies is to provide You with a more
              personal experience and to avoid You having to re-enter your preferences every time You use the Website.
            </li>
          </ul>
        </li>
        <li className={classes.text}>
          <strong>Tracking and Performance Cookies</strong>
          <ul className={classes.list}>
            <li className={classes.text}>Type: Persistent Cookies</li>
            <li className={classes.text}>Administered by: Third-Parties</li>
            <li className={classes.text}>
              Purpose: These Cookies are used to track information about traffic to the Website and how users use the
              Website. The information gathered via these Cookies may directly or indirectly identify you as an
              individual visitor. This is because the information collected is typically linked to a pseudonymous
              identifier associated with the device you use to access the Website. We may also use these Cookies to test
              new pages, features or new functionality of the Website to see how our users react to them.
            </li>
          </ul>
        </li>
      </ul>
      <Text className={classes.text}>
        For more information about the cookies we use and your choices regarding cookies, please visit our Cookies
        Policy or the Cookies section of our Privacy Policy.
      </Text>
      <Title className={classes.subtitle}>IV. Use of Your Personal Data</Title>
      <Text className={classes.text}>The Company may use Personal Data for the following purposes:</Text>
      <ul className={classes.list}>
        <li className={classes.text}>
          <strong>To provide and maintain our Service</strong>, including to monitor the usage of our Service.
        </li>
        <li className={classes.text}>
          <strong>To manage Your Account</strong>: to manage Your registration as a user of the Service. The Personal
          Data You provide can give You access to different functionalities of the Service that are available to You as
          a registered user.
        </li>
        <li className={classes.text}>
          <strong>For the performance of a contract</strong>: the development, compliance and undertaking of the
          purchase contract for the products, items or services You have purchased or of any other contract with Us
          through the Service.
        </li>
        <li className={classes.text}>
          <strong>To contact You</strong>: To contact You by email, telephone calls, SMS, or other equivalent forms of
          electronic communication, such as a mobile application&apos;s push notifications regarding updates or
          informative communications related to the functionalities, products or contracted services, including the
          security updates, when necessary or reasonable for their implementation.
        </li>
        <li className={classes.text}>
          <strong>To provide You with news, special offers and general information</strong> about other goods, services
          and events which we offer that are similar to those that you have already purchased or enquired about unless
          You have opted not to receive such information.
        </li>
        <li className={classes.text}>
          <strong>To manage Your requests</strong>: To attend and manage Your requests to Us.
        </li>
        <li className={classes.text}>
          <strong>For business transfers</strong>: We may use Your information to evaluate or conduct a merger,
          divestiture, restructuring, reorganization, dissolution, or other sale or transfer of some or all of Our
          assets, whether as a going concern or as part of bankruptcy, liquidation, or similar proceeding, in which
          Personal Data held by Us about our Service users is among the assets transferred.
        </li>
        <li className={classes.text}>
          <strong>For other purposes</strong>: We may use Your information for other purposes, such as data analysis,
          identifying usage trends, determining the effectiveness of our promotional campaigns and to evaluate and
          improve our Service, products, services, marketing and your experience.
        </li>
      </ul>
      <Text className={classes.text}>We may share Your personal information in the following situations:</Text>
      <ul className={classes.list}>
        <li className={classes.text}>
          <strong>With Service Providers</strong>: We may share Your personal information with Service Providers to
          monitor and analyze the use of our Service, for payment processing, to contact You.
        </li>
        <li className={classes.text}>
          <strong>For business transfers</strong>: We may share or transfer Your personal information in connection
          with, or during negotiations of, any merger, sale of Company assets, financing, or acquisition of all or a
          portion of Our business to another company.
        </li>
        <li className={classes.text}>
          <strong>With Affiliates</strong>: We may share Your information with Our affiliates, in which case we will
          require those affiliates to honor this Privacy Policy. Affiliates include Our parent company and any other
          subsidiaries, joint venture partners or other companies that We control or that are under common control with
          Us.
        </li>
        <li className={classes.text}>
          <strong>With business partners</strong>: We may share Your information with Our business partners to offer You
          certain products, services or promotions.
        </li>
        <li className={classes.text}>
          <strong>With other users</strong>: when You share personal information or otherwise interact in the public
          areas with other users, such information may be viewed by all users and may be publicly distributed outside.
        </li>
        <li className={classes.text}>
          <strong>With Your consent</strong>: We may disclose Your personal information for any other purpose with Your
          consent.
        </li>
      </ul>
      <Title className={classes.subtitle}>Retention of Your Personal Data</Title>
      <Text className={classes.text}>
        The Company will retain Your Personal Data only for as long as is necessary for the purposes set out in this
        Privacy Policy. We will retain and use Your Personal Data to the extent necessary to comply with our legal
        obligations (for example, if we are required to retain your data to comply with applicable laws), resolve
        disputes, and enforce our legal agreements and policies.
      </Text>
      <Text className={classes.text}>
        The Company will also retain Usage Data for internal analysis purposes. Usage Data is generally retained for a
        shorter period of time, except when this data is used to strengthen the security or to improve the functionality
        of Our Service, or We are legally obligated to retain this data for longer time periods.
      </Text>
      <Title className={classes.subtitle}>Transfer of Your Personal Data</Title>
      <Text className={classes.text}>
        Your information, including Personal Data, is processed at the Company&apos;s operating offices and in any other
        places where the parties involved in the processing are located. It means that this information may be
        transferred to — and maintained on — computers located outside of Your state, province, country or other
        governmental jurisdiction where the data protection laws may differ than those from Your jurisdiction.
      </Text>
      <Text className={classes.text}>
        Your consent to this Privacy Policy followed by Your submission of such information represents Your agreement to
        that transfer.
      </Text>
      <Text className={classes.text}>
        The Company will take all steps reasonably necessary to ensure that Your data is treated securely and in
        accordance with this Privacy Policy and no transfer of Your Personal Data will take place to an organization or
        a country unless there are adequate controls in place including the security of Your data and other personal
        information.
      </Text>
      <Title className={classes.subtitle}>V. Disclosure of Your Personal Data</Title>
      <Text className={classes.text}>
        <strong>Business Transactions</strong>
      </Text>
      <Text className={classes.text}>
        If the Company is involved in a merger, acquisition or asset sale, Your Personal Data may be transferred. We
        will provide notice before Your Personal Data is transferred and becomes subject to a different Privacy Policy.
      </Text>
      <Text className={classes.text}>
        <strong>Law enforcement</strong>
      </Text>
      <Text className={classes.text}>
        Under certain circumstances, the Company may be required to disclose Your Personal Data if required to do so by
        law or in response to valid requests by public authorities (e.g. a court or a government agency).
      </Text>
      <Text className={classes.text}>
        <strong>Other legal requirements</strong>
      </Text>
      <Text className={classes.text}>
        The Company may disclose Your Personal Data in the good faith belief that such action is necessary to:
      </Text>
      <ul className={classes.list}>
        <li className={classes.text}>Comply with a legal obligation</li>
        <li className={classes.text}>Protect and defend the rights or property of the Company</li>
        <li className={classes.text}>Prevent or investigate possible wrongdoing in connection with the Service</li>
        <li className={classes.text}>Protect the personal safety of Users of the Service or the public</li>
        <li className={classes.text}>Protect against legal liability</li>
      </ul>
      <Title className={classes.subtitle}>VI. Security of Your Personal Data</Title>
      <Text className={classes.text}>
        The security of Your Personal Data is important to Us, but remember that no method of transmission over the
        Internet, or method of electronic storage is 100% secure. While We strive to use commercially acceptable means
        to protect Your Personal Data, We cannot guarantee its absolute security.
      </Text>
      <Title className={classes.subtitle}>Detailed Information on the Processing of Your Personal Data</Title>
      <Text className={classes.text}>
        The Service Providers We use may have access to Your Personal Data. These third-party vendors collect, store,
        use, process and transfer information about Your activity on Our Service in accordance with their Privacy
        Policies.
      </Text>
      <Title className={classes.subtitle}>Analytics</Title>
      <Text className={classes.text}>
        We may use third-party Service providers to monitor and analyze the use of our Service.
      </Text>
      <Title className={classes.subtitle}>Email Marketing</Title>
      <Text className={classes.text}>
        We may use Your Personal Data to contact You with newsletters, marketing or promotional materials and other
        information that may be of interest to You. You may opt-out of receiving any, or all, of these communications
        from Us by following the unsubscribe link or instructions provided in any email We send or by contacting Us.
      </Text>
      <Title className={classes.subtitle}>Payments</Title>
      <Text className={classes.text}>
        We may provide paid products and/or services within the Service. In that case, we may use third-party services
        for payment processing (e.g. payment processors).
      </Text>
      <Text className={classes.text}>
        We will not store or collect Your payment card details. That information is provided directly to Our third-party
        payment processors whose use of Your personal information is governed by their Privacy Policy. These payment
        processors adhere to the standards set by PCI-DSS as managed by the PCI Security Standards Council, which is a
        joint effort of brands like Visa, Mastercard, American Express and Discover. PCI-DSS requirements help ensure
        the secure handling of payment information.
      </Text>
      <Title className={classes.subtitle}>VII. CCPA Privacy Policy</Title>
      <Text className={classes.text}>
        This privacy notice section for California residents supplements the information contained in Our Privacy Policy
        and it applies solely to all visitors, users, and others who reside in the State of California.
      </Text>
      <Title className={classes.subtitle}>Categories of Personal Information Collected</Title>
      <Text className={classes.text}>
        We collect information that identifies, relates to, describes, references, is capable of being associated with,
        or could reasonably be linked, directly or indirectly, with a particular Consumer or Device. The following is a
        list of categories of personal information which we may collect or may have been collected from California
        residents within the last twelve (12) months.
      </Text>
      <Text className={classes.text}>
        Please note that the categories and examples provided in the list below are those defined in the CCPA. This does
        not mean that all examples of that category of personal information were in fact collected by Us, but reflects
        our good faith belief to the best of our knowledge that some of that information from the applicable category
        may be and may have been collected. For example, certain categories of personal information would only be
        collected if You provided such personal information directly to Us.
      </Text>
      <ul className={classes.list}>
        <li className={classes.text}>
          <strong>Category A: Identifiers.</strong>
          <ul className={classes.list}>
            <li className={classes.text}>
              Examples: A real name, alias, postal address, unique personal identifier, online identifier, Internet
              Protocol address, email address, account name, driver&apos;s license number, passport number, or other
              similar identifiers.
            </li>
            <li className={classes.text}>Collected: Yes.</li>
          </ul>
        </li>
        <li className={classes.text}>
          <strong>
            Category B: Personal information categories listed in the California Customer Records statute (Cal. Civ.
            Code § 1798.80(e)).
          </strong>
          <ul className={classes.list}>
            <li className={classes.text}>
              Examples: A name, signature, Social Security number, physical characteristics or description, address,
              telephone number, passport number, driver&apos;s license or state identification card number, insurance
              policy number, education, employment, employment history, bank account number, credit card number, debit
              card number, or any other financial information, medical information, or health insurance information.
              Some personal information included in this category may overlap with other categories.
            </li>
            <li className={classes.text}>Collected: Yes.</li>
          </ul>
        </li>
        <li className={classes.text}>
          <strong>Category C: Protected classification characteristics under California or federal law.</strong>
          <ul className={classes.list}>
            <li className={classes.text}>
              Examples: Age (40 years or older), race, color, ancestry, national origin, citizenship, religion or creed,
              marital status, medical condition, physical or mental disability, sex (including gender, gender identity,
              gender expression, pregnancy or childbirth and related medical conditions), sexual orientation, veteran or
              military status, genetic information (including familial genetic information).
            </li>
            <li className={classes.text}>Collected: No.</li>
          </ul>
        </li>
        <li className={classes.text}>
          <strong>Category D: Commercial information.</strong>
          <ul className={classes.list}>
            <li className={classes.text}>
              Examples: Records and history of products or services purchased or considered.
            </li>
            <li className={classes.text}>Collected: Yes.</li>
          </ul>
        </li>
        <li className={classes.text}>
          <strong>Category E: Biometric information.</strong>
          <ul className={classes.list}>
            <li className={classes.text}>
              Examples: Genetic, physiological, behavioral, and biological characteristics, or activity patterns used to
              extract a template or other identifier or identifying information, such as, fingerprints, faceprints, and
              voiceprints, iris or retina scans, keystroke, gait, or other physical patterns, and sleep, health, or
              exercise data.
            </li>
            <li className={classes.text}>Collected: No.</li>
          </ul>
        </li>
        <li className={classes.text}>
          <strong>Category F: Internet or other similar network activity.</strong>
          <ul className={classes.list}>
            <li className={classes.text}>Examples: Interaction with our Service or advertisement.</li>
            <li className={classes.text}>Collected: Yes.</li>
          </ul>
        </li>
        <li className={classes.text}>
          <strong>Category G: Geolocation data.</strong>
          <ul className={classes.list}>
            <li className={classes.text}>Examples: Approximate physical location.</li>
            <li className={classes.text}>Collected: No.</li>
          </ul>
        </li>
        <li className={classes.text}>
          <strong>Category H: Sensory data.</strong>
          <ul className={classes.list}>
            <li className={classes.text}>
              Examples: Audio, electronic, visual, thermal, olfactory, or similar information.
            </li>
            <li className={classes.text}>Collected: No.</li>
          </ul>
        </li>
        <li className={classes.text}>
          <strong>Category I: Professional or employment-related information.</strong>
          <ul className={classes.list}>
            <li className={classes.text}>Examples: Current or past job history or performance evaluations.</li>
            <li className={classes.text}>Collected: No.</li>
          </ul>
        </li>
        <li className={classes.text}>
          <strong>
            Category J: Non-public education information (per the Family Educational Rights and Privacy Act (20 U.S.C.
            Section 1232g, 34 C.F.R. Part 99)).
          </strong>
          <ul className={classes.list}>
            <li className={classes.text}>
              Examples: Education records directly related to a student maintained by an educational institution or
              party acting on its behalf, such as grades, transcripts, class lists, student schedules, student
              identification codes, student financial information, or student disciplinary records.
            </li>
            <li className={classes.text}>Collected: No.</li>
          </ul>
        </li>
        <li className={classes.text}>
          <strong>Category K: Inferences drawn from other personal information.</strong>
          <ul className={classes.list}>
            <li className={classes.text}>
              Examples: Profile reflecting a person&apos;s preferences, characteristics, psychological trends,
              predispositions, behavior, attitudes, intelligence, abilities, and aptitudes.
            </li>
            <li className={classes.text}>Collected: No.</li>
          </ul>
        </li>
      </ul>
      <Text className={classes.text}>Under CCPA, personal information does not include:</Text>
      <ul className={classes.list}>
        <li className={classes.text}>Publicly available information from government records</li>
        <li className={classes.text}>Deidentified or aggregated consumer information</li>
        <li className={classes.text}>
          Information excluded from the CCPA&apos;s scope, such as:
          <ul className={classes.list}>
            <li className={classes.text}>
              Health or medical information covered by the Health Insurance Portability and Accountability Act of 1996
              (HIPAA) and the California Confidentiality of Medical Information Act (CMIA) or clinical trial data
            </li>
            <li className={classes.text}>
              Personal Information covered by certain sector-specific privacy laws, including the Fair Credit Reporting
              Act (FRCA), the Gramm-Leach-Bliley Act (GLBA) or California Financial Information Privacy Act (FIPA), and
              the Driver&apos;s Privacy Protection Act of 1994
            </li>
          </ul>
        </li>
      </ul>
      <Title className={classes.subtitle}>Sources of Personal Information</Title>
      <Text className={classes.text}>
        We obtain the categories of personal information listed above from the following categories of sources:
      </Text>
      <ul className={classes.list}>
        <li className={classes.text}>
          Directly from You. For example, from the forms You complete on our Service, preferences You express or provide
          through our Service, or from Your purchases on our Service.
        </li>
        <li className={classes.text}>Indirectly from You. For example, from observing Your activity on our Service.</li>
        <li className={classes.text}>
          Automatically from You. For example, through cookies We or our Service Providers set on Your Device as You
          navigate through our Service.
        </li>
        <li className={classes.text}>
          From Service Providers. For example, third-party vendors to monitor and analyze the use of our Service,
          third-party vendors for payment processing, or other third-party vendors that We use to provide the Service to
          You.
        </li>
      </ul>
      <Title className={classes.subtitle}>
        Use of Personal Information for Business Purposes or Commercial Purposes
      </Title>
      <Text className={classes.text}>
        We may use or disclose personal information We collect for &quot;business purposes&quot; or &quot;commercial
        purposes&quot; (as defined under the CCPA), which may include the following examples:
      </Text>
      <ul className={classes.list}>
        <li className={classes.text}>To operate our Service and provide You with our Service.</li>
        <li className={classes.text}>
          To provide You with support and to respond to Your inquiries, including to investigate and address Your
          concerns and monitor and improve our Service.
        </li>
        <li className={classes.text}>
          To fulfill or meet the reason You provided the information. For example, if You share Your contact information
          to ask a question about our Service, We will use that personal information to respond to Your inquiry. If You
          provide Your personal information to purchase a product or service, We will use that information to process
          Your payment and facilitate delivery.
        </li>
        <li className={classes.text}>
          To respond to law enforcement requests and as required by applicable law, court order, or governmental
          regulations.
        </li>
        <li className={classes.text}>
          As described to You when collecting Your personal information or as otherwise set forth in the CCPA.
        </li>
        <li className={classes.text}>For internal administrative and auditing purposes.</li>
        <li className={classes.text}>
          To detect security incidents and protect against malicious, deceptive, fraudulent or illegal activity,
          including, when necessary, to prosecute those responsible for such activities.
        </li>
      </ul>
      <Text className={classes.text}>
        Please note that the examples provided above are illustrative and not intended to be exhaustive.
      </Text>
      <Text className={classes.text}>
        For more details on how we use this information, please refer to the &quot;Use of Your Personal Data&quot;
        section.
      </Text>
      <Text className={classes.text}>
        If We decide to collect additional categories of personal information or use the personal information We
        collected for materially different, unrelated, or incompatible purposes We will update this Privacy Policy.
      </Text>
      <Title className={classes.subtitle}>
        Disclosure of Personal Information for Business Purposes or Commercial Purposes
      </Title>
      <Text className={classes.text}>
        We may use or disclose and may have used or disclosed in the last twelve (12) months the following categories of
        personal information for business or commercial purposes:
      </Text>
      <ul className={classes.list}>
        <li className={classes.text}>Category A: Identifiers</li>
        <li className={classes.text}>
          Category B: Personal information categories listed in the California Customer Records statute (Cal. Civ. Code
          § 1798.80(e))
        </li>
        <li className={classes.text}>Category D: Commercial information</li>
        <li className={classes.text}>Category F: Internet or other similar network activity</li>
      </ul>
      <Text className={classes.text}>
        Please note that the categories listed above are those defined in the CCPA. This does not mean that all examples
        of that category of personal information were in fact disclosed, but reflects our good faith belief to the best
        of our knowledge that some of that information from the applicable category may be and may have been disclosed.
      </Text>
      <Text className={classes.text}>
        When We disclose personal information for a business purpose or a commercial purpose, We enter a contract that
        describes the purpose and requires the recipient to both keep that personal information confidential and not use
        it for any purpose except performing the contract.
      </Text>
      <Title className={classes.subtitle}>Sale of Personal Information</Title>
      <Text className={classes.text}>
        As defined in the CCPA, &quot;sell&quot; and &quot;sale&quot; mean selling, renting, releasing, disclosing,
        disseminating, making available, transferring, or otherwise communicating orally, in writing, or by electronic
        or other means, a consumer&apos;s personal information by the business to a third party for valuable
        consideration. This means that We may have received some kind of benefit in return for sharing personal
        information, but not necessarily a monetary benefit.
      </Text>
      <Text className={classes.text}>
        Please note that the categories listed below are those defined in the CCPA. This does not mean that all examples
        of that category of personal information were in fact sold, but reflects our good faith belief to the best of
        our knowledge that some of that information from the applicable category may be and may have been shared for
        value in return.
      </Text>
      <ul className={classes.list}>
        <li className={classes.text}>Category A: Identifiers</li>
        <li className={classes.text}>
          Category B: Personal information categories listed in the California Customer Records statute (Cal. Civ. Code
          § 1798.80(e))
        </li>
        <li className={classes.text}>Category D: Commercial information</li>
        <li className={classes.text}>Category F: Internet or other similar network activity</li>
      </ul>
      <Title className={classes.subtitle}>Share of Personal Information</Title>
      <Text className={classes.text}>
        We may share Your personal information identified in the above categories with the following categories of third
        parties:
      </Text>
      <ul className={classes.list}>
        <li className={classes.text}>Service Providers</li>
        <li className={classes.text}>Payment processors</li>
        <li className={classes.text}>Our affiliates</li>
        <li className={classes.text}>Our business partners</li>
        <li className={classes.text}>
          Third party vendors to whom You or Your agents authorize Us to disclose Your personal information in
          connection with products or services We provide to You
        </li>
      </ul>
      <Title className={classes.subtitle}>Sale of Personal Information of Minors Under 16 Years of Age</Title>
      <Text className={classes.text}>
        We do not knowingly collect personal information from minors under the age of 16 through our Service, although
        certain third-party websites that we link to may do so. These third-party websites have their own terms of use
        and privacy policies and we encourage parents and legal guardians to monitor their children&apos;s Internet
        usage and instruct their children to never provide information on other websites without their permission.
      </Text>
      <Text className={classes.text}>
        We do not sell the personal information of Consumers We actually know are less than 16 years of age, unless We
        receive affirmative authorization (the &quot;right to opt-in&quot;) from either the Consumer who is between 13
        and 16 years of age, or the parent or guardian of a Consumer less than 13 years of age. Consumers who opt-in to
        the sale of personal information may opt-out of future sales at any time. To exercise the right to opt-out, You
        (or Your authorized representative) may submit a request to Us by contacting Us.
      </Text>
      <Text className={classes.text}>
        If You have reason to believe that a child under the age of 13 (or 16) has provided Us with personal
        information, please contact Us with sufficient detail to enable Us to delete that information.
      </Text>
      <Title className={classes.subtitle}>Your Rights under the CCPA</Title>
      <Text className={classes.text}>
        The CCPA provides California residents with specific rights regarding their personal information. If You are a
        resident of California, You have the following rights:
      </Text>
      <ul className={classes.list}>
        <li className={classes.text}>
          <strong>The right to notice.</strong> You have the right to be notified which categories of Personal Data are
          being collected and the purposes for which the Personal Data is being used.
        </li>
        <li className={classes.text}>
          <strong>The right to request.</strong> Under CCPA, You have the right to request that We disclose information
          to You about Our collection, use, sale, disclosure for business purposes and share of personal information.
          Once We receive and confirm Your request, We will disclose to You:
          <ul className={classes.list}>
            <li className={classes.text}>The categories of personal information We collected about You</li>
            <li className={classes.text}>
              The categories of sources for the personal information We collected about You
            </li>
            <li className={classes.text}>
              Our business or commercial purpose for collecting or selling that personal information
            </li>
            <li className={classes.text}>
              The categories of third parties with whom We share that personal information
            </li>
            <li className={classes.text}>The specific pieces of personal information We collected about You</li>
            <li className={classes.text}>
              If we sold Your personal information or disclosed Your personal information for a business purpose, We
              will disclose to You:
              <ul className={classes.list}>
                <li className={classes.text}>The categories of personal information categories sold</li>
                <li className={classes.text}>The categories of personal information categories disclosed</li>
              </ul>
            </li>
          </ul>
        </li>
        <li className={classes.text}>
          <strong>The right to say no to the sale of Personal Data (opt-out).</strong> You have the right to direct Us
          to not sell Your personal information. To submit an opt-out request please contact Us.
        </li>
        <li className={classes.text}>
          <strong>The right to delete Personal Data.</strong> You have the right to request the deletion of Your
          Personal Data, subject to certain exceptions. Once We receive and confirm Your request, We will delete (and
          direct Our Service Providers to delete) Your personal information from our records, unless an exception
          applies. We may deny Your deletion request if retaining the information is necessary for Us or Our Service
          Providers to:
          <ul className={classes.list}>
            <li className={classes.text}>
              Complete the transaction for which We collected the personal information, provide a good or service that
              You requested, take actions reasonably anticipated within the context of our ongoing business relationship
              with You, or otherwise perform our contract with You.
            </li>
            <li className={classes.text}>
              Detect security incidents, protect against malicious, deceptive, fraudulent, or illegal activity, or
              prosecute those responsible for such activities.
            </li>
            <li className={classes.text}>
              Debug products to identify and repair errors that impair existing intended functionality.
            </li>
            <li className={classes.text}>
              Exercise free speech, ensure the right of another consumer to exercise their free speech rights, or
              exercise another right provided for by law.
            </li>
            <li className={classes.text}>
              Comply with the California Electronic Communications Privacy Act (Cal. Penal Code § 1546 et. seq.).
            </li>
            <li className={classes.text}>
              Engage in public or peer-reviewed scientific, historical, or statistical research in the public interest
              that adheres to all other applicable ethics and privacy laws, when the information&apos;s deletion may
              likely render impossible or seriously impair the research&apos;s achievement, if You previously provided
              informed consent.
            </li>
            <li className={classes.text}>
              Enable solely internal uses that are reasonably aligned with consumer expectations based on Your
              relationship with Us.
            </li>
            <li className={classes.text}>Comply with a legal obligation.</li>
            <li className={classes.text}>
              Make other internal and lawful uses of that information that are compatible with the context in which You
              provided it.
            </li>
          </ul>
        </li>
        <li className={classes.text}>
          <strong>The right not to be discriminated against.</strong> You have the right not to be discriminated against
          for exercising any of Your consumer&apos;s rights, including by:
          <ul className={classes.list}>
            <li className={classes.text}>Denying goods or services to You</li>
            <li className={classes.text}>
              Charging different prices or rates for goods or services, including the use of discounts or other benefits
              or imposing penalties
            </li>
            <li className={classes.text}>Providing a different level or quality of goods or services to You</li>
            <li className={classes.text}>
              Suggesting that You will receive a different price or rate for goods or services or a different level or
              quality of goods or services
            </li>
          </ul>
        </li>
      </ul>
      <Title className={classes.subtitle}>Exercising Your CCPA Data Protection Rights</Title>
      <Text className={classes.text}>
        In order to exercise any of Your rights under the CCPA, and if You are a California resident, You can contact
        Us:
      </Text>
      <ul className={classes.list}>
        <li className={classes.text}>
          By visiting this page on our website: <a>www.swappm.com</a>
        </li>
        <li className={classes.text}>By sending us an email: support@swappm.com</li>
      </ul>
      <Text className={classes.text}>
        Only You, or a person registered with the California Secretary of State that You authorize to act on Your
        behalf, may make a verifiable request related to Your personal information.
      </Text>
      <Text className={classes.text}>Your request to Us must:</Text>
      <ul className={classes.list}>
        <li className={classes.text}>
          Provide sufficient information that allows Us to reasonably verify You are the person about whom We collected
          personal information or an authorized representative
        </li>
        <li className={classes.text}>
          Describe Your request with sufficient detail that allows Us to properly understand, evaluate, and respond to
          it
        </li>
      </ul>
      <Text className={classes.text}>
        We cannot respond to Your request or provide You with the required information if we cannot:
      </Text>
      <ul className={classes.list}>
        <li className={classes.text}>Verify Your identity or authority to make the request</li>
        <li className={classes.text}>And confirm that the personal information relates to You</li>
      </ul>
      <Text className={classes.text}>
        We will disclose and deliver the required information free of charge within 45 days of receiving Your verifiable
        request. The time period to provide the required information may be extended once by an additional 45 days when
        reasonably necessary and with prior notice.
      </Text>
      <Text className={classes.text}>
        Any disclosures We provide will only cover the 12-month period preceding the verifiable request&apos;s receipt.
      </Text>
      <Text className={classes.text}>
        For data portability requests, We will select a format to provide Your personal information that is readily
        usable and should allow You to transmit the information from one entity to another entity without hindrance.
      </Text>
      <Title className={classes.subtitle}>VIII. Do Not Sell My Personal Information</Title>
      <Text className={classes.text}>
        You have the right to opt-out of the sale of Your personal information. Once We receive and confirm a verifiable
        consumer request from You, we will stop selling Your personal information. To exercise Your right to opt-out,
        please contact Us.
      </Text>
      <Text className={classes.text}>
        The Service Providers we partner with (for example, our analytics or advertising partners) may use technology on
        the Service that sells personal information as defined by the CCPA law. If you wish to opt out of the use of
        Your personal information for interest-based advertising purposes and these potential sales as defined under
        CCPA law, you may do so by following the instructions below.
      </Text>
      <Text className={classes.text}>
        Please note that any opt out is specific to the browser You use. You may need to opt out on every browser that
        You use.
      </Text>
      <Title className={classes.subtitle}>IX. Website</Title>
      <Text className={classes.text}>
        You can opt out of receiving ads that are personalized as served by our Service Providers by following our
        instructions presented on the Service:
      </Text>
      <ul className={classes.list}>
        <li className={classes.text}>
          The NAI&apos;s opt-out platform:{' '}
          <a href='http://www.networkadvertising.org/choices/'>http://www.networkadvertising.org/choices/</a>
        </li>
        <li className={classes.text}>
          The EDAA&apos;s opt-out platform:{' '}
          <a href='http://www.youronlinechoices.com/'>http://www.youronlinechoices.com/</a>
        </li>
        <li className={classes.text}>
          The DAA&apos;s opt-out platform:{' '}
          <a href='http://optout.aboutads.info/?c=2&lang=EN'>http://optout.aboutads.info/?c=2&lang=EN</a>
        </li>
      </ul>
      <Text className={classes.text}>
        The opt out will place a cookie on Your computer that is unique to the browser You use to opt out. If you change
        browsers or delete the cookies saved by your browser, You will need to opt out again.
      </Text>
      <Title className={classes.subtitle}>X. Mobile Devices</Title>
      <Text className={classes.text}>
        Your mobile device may give You the ability to opt out of the use of information about the apps You use in order
        to serve You ads that are targeted to Your interests:
      </Text>
      <ul className={classes.list}>
        <li className={classes.text}>
          Opt out of Interest-Based Ads or Opt out of Ads Personalization on Android devices
        </li>
        <li className={classes.text}>Limit Ad Tracking on iOS devices</li>
      </ul>
      <Text className={classes.text}>
        You can also stop the collection of location information from Your mobile device by changing the preferences on
        Your mobile device.
      </Text>
      <Title className={classes.subtitle}>XI. Children&apos;s Privacy</Title>
      <Text className={classes.text}>
        Our Service does not address anyone under the age of 13. We do not knowingly collect personally identifiable
        information from anyone under the age of 13. If You are a parent or guardian and You are aware that Your child
        has provided Us with Personal Data, please contact Us. If We become aware that We have collected Personal Data
        from anyone under the age of 13 without verification of parental consent, We take steps to remove that
        information from Our servers.
      </Text>
      <Text className={classes.text}>
        If We need to rely on consent as a legal basis for processing Your information and Your country requires consent
        from a parent, We may require Your parent&apos;s consent before We collect and use that information.
      </Text>
      <Title className={classes.subtitle}>XII. Links to Other Websites</Title>
      <Text className={classes.text}>
        Our Service may contain links to other websites that are not operated by Us. If You click on a third party link,
        You will be directed to that third party&apos;s site. We strongly advise You to review the Privacy Policy of
        every site You visit.
      </Text>
      <Text className={classes.text}>
        We have no control over and assume no responsibility for the content, privacy policies or practices of any third
        party sites or services.
      </Text>
      <Title className={classes.subtitle}>XIII. Changes to this Privacy Policy</Title>
      <Text className={classes.text}>
        We may update Our Privacy Policy from time to time. We will notify You of any changes by posting the new Privacy
        Policy on this page.
      </Text>
      <Text className={classes.text}>
        We will let You know via email and/or a prominent notice on Our Service, prior to the change becoming effective
        and update the &ldquo;Last updated&ldquo; date at the top of this Privacy Policy.
      </Text>
      <Text className={classes.text}>
        You are advised to review this Privacy Policy periodically for any changes. Changes to this Privacy Policy are
        effective when they are posted on this page.
      </Text>
      <Title className={classes.subtitle}>XIV. Contact Us</Title>
      <Text className={classes.text}>If you have any questions about this Privacy Policy, You can contact us:</Text>
      <ul className={classes.list}>
        <li className={classes.text}>By visiting this page on our website: www.swappm.com</li>
        <li className={classes.text}>By sending us an email: support@swappm.com</li>
      </ul>
      <Text className={classes.text}>Last updated: July 14, 2023</Text>
    </Container>
  )
}

export default PrivacyPolicy
